package editor.structure

import three.js.Vector3

val Structure.center: Vector3 get() {
    val min = Vector3()
    val max = Vector3()
    forEach {
        min.min(it.object3D.position)
        max.max(it.object3D.position)
    }
    return min.add(max).multiplyScalar(0.5)
}

fun Structure.instantiate() = map(StructureElement::object3D).toTypedArray()